import React, { useState, useEffect } from "react";

import { Link } from "react-router-dom";
import "../sidebar.css";
import { Table, Container } from "react-bootstrap";
import AddInput from "./AddInput";
import EditTodo from "./EditTodo";
import axios from "axios";
import { Configs } from "../api";

const AdminTable = () => {
  const [locData, setdata] = useState([]);
  const [catID, setcatID] = useState("");

  useEffect(() => {
    loaddata();
  }, []);

  const loaddata = async () => {
    try {
      const result = await axios.get(Configs.extras);
      // console.log('ppppppppppppppppppppp')
      //  console.log(result.data.extras)

      if (result.data.extras.length !== null) {
        setdata(result.data.extras);
      } else {
        console.log("null");
      }
    } catch (error) {
      console.log(error.message);
    }
  };
  const deleteTodo = async (id) => {
    // console.log(id)
    try {
      const deleteTodo = await axios.delete(Configs.extras + "/" + id);
      setdata(locData.filter((todo) => todo._id !== id));
    } catch (error) {
      console.log(error.message);
    }
  };

  return (
    <Container className="table-cont">
      <AddInput />

      <Table className="table-css" striped bordered hover>
        <thead>
          <tr>
            <th>Name</th>
            <th>Price</th>

            <th>Items</th>
            <th>Extras</th>
            <th>Edit</th>
            <th>Delete</th>
          </tr>
        </thead>
        <tbody>
          {locData.map((todo) => (
            <tr key={todo._id}>
              <td>{todo.name}</td>
              <td>{todo.price}</td>

              <td>{todo.itemId ? todo.itemId.name : "Items Deleted"}</td>
              <td>
                {todo.extrasavailable
                  ? "Extras Available"
                  : "Extras Not Available"}
              </td>

              <td>
                <Link
                  to={{
                    pathname: "/dashboard/extras/" + todo._id,
                  }}
                  className="btn btn-primary"
                >
                  Edit
                </Link>
              </td>
              <td>
                <button
                  className="btn btn-danger"
                  onClick={(e) => deleteTodo(todo._id)}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Container>
  );
};

export default AdminTable;
